module.exports = require("@palmabit/react-cookie-law");